import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { Construction as ConstructionIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';

const MaintenancePage: React.FC = () => {
  return (
    <Box 
      sx={{ 
        minHeight: '100vh', 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center',
        bgcolor: '#f5f5f5',
        p: 3
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{ 
          width: '100%', 
          maxWidth: 600,
          textAlign: 'center'
        }}
      >
        <Paper 
          elevation={3} 
          sx={{ 
            p: 5, 
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <ConstructionIcon sx={{ fontSize: 80, color: 'warning.main', mb: 3 }} />
          
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            Site Under Maintenance
          </Typography>
          
          <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
            We're currently performing scheduled maintenance on our website. 
            Please check back soon. We apologize for any inconvenience.
          </Typography>
          
          <Box sx={{ mt: 2 }}>
            <Button 
              variant="contained" 
              color="primary"
              href="mailto:info@paragonlivedesign.com"
            >
              Contact Us
            </Button>
          </Box>
          
          <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
            &copy; {new Date().getFullYear()} Paragon Live Design. All rights reserved.
          </Typography>
        </Paper>
      </motion.div>
    </Box>
  );
};

export default MaintenancePage; 